/*jshint esversion: 6 */

const request = require('request');

const POST = 'POST';
const GET = 'GET';

function make_request(url, method, raw_token, obj, on_success, on_error){
  var options;
  let token = new Buffer("_:" + raw_token).toString('base64');
  //console.log("tk:", token);
  options = {
      uri: url,
      method: method,
      json:obj,
      headers: {
        'content-type': 'application/json'
      },
      timeout: 40000
  };
  if (token.length>5){
      options.headers['Authorization'] = 'Basic '+token;

  }
  request(options, function (error, response, body) {
      if (!error && response.statusCode === 200) {
          var resp_data = null
          if (typeof(body)==='string'){
              resp_data = JSON.parse(body);
          }else{
              resp_data = body;
          }
          if (body.StatusCode===200){
            return on_success(body);
          }
          if (resp_data.code===200){
              return on_success(body.data);
          }else{
              if (body.code === 401 || body.code === 403){
                  return on_error(body.code, "Session expired, please log in agin.");
              }else{
                  return on_error(body.code, body.data.error);
              }
          }
      }
      else{
          console.log(error);
          return on_error(0, 'The network is temporarily inaccessible, Please check your internet connection');
      }

  });
}

function _uri(path){
  let domain = 'https://talk.atoken.org';
  //let domain = 'http://localhost:8080';
  return domain + path;
  //return "http://"+ API_DOMAIN + path;
}


export default {
  api_post(path, token, data, on_success, on_error){
    let url = _uri(path);
    console.log('will access:', url);
    make_request(url, POST, token, data, on_success, on_error);
  },
  api_get(path, token, on_success, on_error){
    make_request(_uri(path), GET, token, {}, on_success, on_error);
  }
};



// WEBPACK FOOTER //
// ./src/services/api.js